import { ICurrentRebalance, IPortfolio } from 'src/app/models/portfolios';
import { IPortfolioDataEntity, IPortfolioPosition, IPortfolioOption } from '../../../models/portfolios';
import { Action } from '@ngrx/store';

export enum PortfoliosActionTypes {
  LOAD_PORTFOLIO_ENTITY = 'LOAD_PORTFOLIO_ENTITY',
  LOAD_PORTFOLIO_ENTITY_SUCCESS = 'LOAD_PORTFOLIO_ENTITY_SUCCESS',
  LOAD_PORTFOLIOS_FOR_ENTITIES = 'LOAD_PORTFOLIOS_FOR_ENTITIES',
  LOAD_PORTFOLIOS_FOR_ENTITIES_SUCCESS = 'LOAD_PORTFOLIOS_FOR_ENTITIES_SUCCESS',
  SELECT_PORTFOLIO_ENTITY_POSITION = 'SELECT_PORTFOLIO_ENTITY_POSITION',
  PORTFOLIOS_DATA_ERROR = 'PORTFOLIOS_DATA_ERROR',
  RESET_SUBMIT_PORTFOLIO_POSITION = 'RESET_SUBMIT_PORTFOLIO_POSITION',
  GET_INVESTOR_PORTFOLIOS = 'GET_INVESTOR_PORTFOLIOS',
  GET_INVESTOR_PORTFOLIOS_SUCCESS = 'GET_INVESTOR_PORTFOLIOS_SUCCESS',
  GET_INVESTOR_PORTFOLIOS_FAIL = 'GET_INVESTOR_PORTFOLIOS_FAIL',
  SEARCH_PORTFOLIOS = 'SEARCH_PORTFOLIOS',
  SEARCH_PORTFOLIOS_SUCCESS = 'SEARCH_PORTFOLIOS_SUCCESS',
  GET_REFERENCE_NUMBER = 'GET_REFERENCE_NUMBER',
  GET_REFERENCE_NUMBER_SUCCESS = 'GET_REFERENCE_NUMBER_SUCCESS',
  GET_REFERENCE_NUMBER_FAIL = 'GET_REFERENCE_NUMBER_FAIL',
  CLEAR_PORTFOLIO_STATE = '[Portfolio] Clear State',
  CANCEL_REBALANCE = 'CANCEL_REBALANCE'
}

export class LoadPortfolioEntity implements Action {
  readonly type = PortfoliosActionTypes.LOAD_PORTFOLIO_ENTITY;
  constructor(public payload: number) { }
}
export class LoadPortfolioEntitySuccess implements Action {
  readonly type = PortfoliosActionTypes.LOAD_PORTFOLIO_ENTITY_SUCCESS;
  constructor(public payload: IPortfolioDataEntity) { }
}
export class LoadPortfoliosForEntities implements Action {
  readonly type = PortfoliosActionTypes.LOAD_PORTFOLIOS_FOR_ENTITIES;
  constructor(public payload: number[]) { }
}
export class LoadPortfoliosForEntitiesSuccess implements Action {
  readonly type = PortfoliosActionTypes.LOAD_PORTFOLIOS_FOR_ENTITIES_SUCCESS;
  constructor(public payload: IPortfolio[]) { }
}
export class SelectPortfolioEntityPosition implements Action {
  readonly type = PortfoliosActionTypes.SELECT_PORTFOLIO_ENTITY_POSITION;
  constructor(public payload: IPortfolioPosition) { }
}
export class ResetSubmitPortfolioPosition implements Action {
  readonly type = PortfoliosActionTypes.RESET_SUBMIT_PORTFOLIO_POSITION;
}



// @ShowLoader()
export class GetInvestorPortfolios implements Action {
  readonly type = PortfoliosActionTypes.GET_INVESTOR_PORTFOLIOS;
}

// @HideLoader(PortfoliosActionTypes.GET_INVESTOR_PORTFOLIOS)
export class GetInvestorPortfoliosSuccess implements Action {
  readonly type = PortfoliosActionTypes.GET_INVESTOR_PORTFOLIOS_SUCCESS;
  constructor(public payload: IPortfolio[]) { }
}

// @HideLoader(PortfoliosActionTypes.GET_INVESTOR_PORTFOLIOS)
export class GetInvestorPortfoliosFail implements Action {
  readonly type = PortfoliosActionTypes.GET_INVESTOR_PORTFOLIOS_FAIL;
  constructor(public payload: any) { }
}

export class SearchPortfolios implements Action {
  readonly type = PortfoliosActionTypes.SEARCH_PORTFOLIOS;
  constructor(public payload: string) { }
}
export class SearchPortfoliosSuccess implements Action {
  readonly type = PortfoliosActionTypes.SEARCH_PORTFOLIOS_SUCCESS;
  constructor(public payload: IPortfolioOption[]) { }
}

export class GetReferenceNumber implements Action {
  readonly type = PortfoliosActionTypes.GET_REFERENCE_NUMBER;
  constructor(public payload: number) { }
}

export class GetReferenceNumberSuccess implements Action {
  readonly type = PortfoliosActionTypes.GET_REFERENCE_NUMBER_SUCCESS;
  constructor(public investorId: number, public referenceNumber: string) { }
}

export class GetReferenceNumberFail implements Action {
  readonly type = PortfoliosActionTypes.GET_REFERENCE_NUMBER_FAIL;
  constructor(public payload: number) { }
}

export type PortfoliosActions = LoadPortfolioEntity | LoadPortfolioEntitySuccess | LoadPortfoliosForEntities | LoadPortfoliosForEntitiesSuccess |
  SelectPortfolioEntityPosition | ResetSubmitPortfolioPosition |
  GetInvestorPortfolios | GetInvestorPortfoliosSuccess | SearchPortfolios | GetInvestorPortfoliosFail |
  SearchPortfoliosSuccess | GetReferenceNumber | GetReferenceNumberSuccess | GetReferenceNumberFail;
